import React from "react";
import Box from "../layout/Box";

export default Box;